import React from 'react';
import { useFormik } from 'formik';
import { EmptyState } from '@/components/custom/empty-state';
import CommentCard from './CommentCard';
import FileCard from './FileCard';
import CommentForm from './CommentForm';
import { useAuditorium } from 'src/app/hooks/useAuditorium';
import { useState, useEffect } from 'react';
import { Loader } from '@/components/custom/loader';
import { t } from 'i18next';
import { Filter, FilterSelectNative } from '@/components/custom/filter';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Chat } from '@/components/custom/chat';
import { ChatBody } from '@/components/custom/chat/chat';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function ChatWidget(props) {
  const { combineMessages, createChat, loading, files, messages } = useAuditorium();
  const { id, messageChatChannel, setPage, messageChats, setChats, hasMoreComments } = props;
  const [teacherLoading, setTeacherLoading] = useState(false);
  const [filteredFiles, setFilteredFiles] = useState([]);

  const commentForm = useFormik({
    initialValues: {},
    onSubmit: handleComment
  });

  const filters = useFormik({
    initialValues: {
      teacher: ''
    }
  });

  function handleComment(values) {
    createChat(id, values);
  }

  const teacherSet = new Set();

  const teachers = files.reduce((uniqueTeachers, file) => {
    if (file.user && file.user.id && !teacherSet.has(file.user.id)) {
      teacherSet.add(file.user.id);
      uniqueTeachers.push(file.user);
    }
    return uniqueTeachers;
  }, []);

  useEffect(() => {
    const { teacher } = filters.values;

    const filteredFiles = files.filter(item => {
      let filterResult = true;
      if (teacher !== '' && teacher !== 'blank') {
        filterResult = filterResult && item.user && item.user.id === parseInt(teacher);
      }
      return filterResult;
    });

    setFilteredFiles(filteredFiles);
  }, [filters.values, files]);

  const messagesWithFiles = messages.filter(message => message?.['auditorium-files']?.length > 0);

  const filesFromMessages = messagesWithFiles.flatMap(message => {
    return message?.['auditorium-files']?.map(item => {
      return { ...item, user: message.user };
    });
  });

  const mergedFiles = [...files, ...filesFromMessages];

  const sortedFilesFromMessages = mergedFiles.slice().sort((a, b) => {
    const dateA = new Date(a['created-at']);
    const dateB = new Date(b['created-at']);
    return dateA - dateB;
  });

  useEffect(() => {
    if (teachers.length === 0) {
      setTeacherLoading(true);
    } else {
      setTeacherLoading(false);
    }
  }, [teachers]);

  return (
    <Tabs
      defaultValue="chat"
      className="grow flex flex-col"
    >
      <TabsList className="self-start">
        <TabsTrigger value="chat">Chat</TabsTrigger>
        <TabsTrigger value="arquivos">Arquivos</TabsTrigger>
      </TabsList>

      <TabsContent
        value="chat"
        className="grow"
      >
        <Chat className="h-full">
          <ChatBody id="scrollableDiv1">
            <InfiniteScroll
              dataLength={messageChats.length}
              next={() => setPage(prevPage => prevPage + 1)}
              hasMore={hasMoreComments}
              inverse={true}
              scrollableTarget="scrollableDiv1"
            >
              {hasMoreComments && <Loader />}

              {messageChats.map(chat => (
                <CommentCard
                  chat={chat}
                  id={id}
                  key={chat.id}
                  messageChats={messageChats}
                  setChats={setChats}
                />
              ))}
            </InfiniteScroll>
          </ChatBody>

          <CommentForm commentForm={commentForm} />
        </Chat>
      </TabsContent>

      <TabsContent
        value="arquivos"
        className="grow"
      >
        <Chat className="h-full">
          {!teacherLoading && (
            <Filter
              variant="plain"
              className="mb-0"
            >
              <FilterSelectNative
                label={t('filter.selectTeacher')}
                blankLabel={t('filter.blankLabelAll2')}
                value={filters.values.teacher}
                onChange={e => {
                  filters.setFieldValue('teacher', e.target.value);
                }}
                options={teachers}
              />
            </Filter>
          )}

          <ChatBody>
            {sortedFilesFromMessages?.length === 0 && (
              <EmptyState
                type="content"
                title={t('emptyState.titleNotFile')}
                text={t('emptyState.textNotFile')}
                variant="plain"
              />
            )}

            {sortedFilesFromMessages.map((f, i) => (
              <FileCard
                file={f}
                key={i}
                id={id}
              />
            ))}
          </ChatBody>
        </Chat>
      </TabsContent>
    </Tabs>
  );
}
